import { render, staticRenderFns } from "./NavigationDropdownItemWithIcon.vue?vue&type=template&id=337189c7"
import script from "./NavigationDropdownItemWithIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigationDropdownItemWithIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports